import request from '@/utils/request';
import { requestEndpoint } from '@/constants/urls';

const cohortCounts = (code, data) => request({
  url: `${requestEndpoint(code)}/cohort/cohort-counts`,
  data,
  method: 'POST',
});

const queryCounts = ({ code, queryId, dictionaryCode }) => cohortCounts(code, {
  query_id: queryId,
  dictionary_code: dictionaryCode,
});

const clauseCounts = ({ code, clauseId }) => cohortCounts(code, {
  clause_id: clauseId,
});

const SystemCohortProfileService = {
  queryCounts,
  clauseCounts,
};

export default SystemCohortProfileService;
